<div class="alert-error col-md-12">
  <app-alert-error></app-alert-error>
</div>
<div class="customer-profile-form-utf-container" id="customer-profile-form-utf-container" *ngIf="!showLoading">
  <form [formGroup]="customerProfileFormGroup">
    <div class="customer-profile-form-utf" id="customer-profile-form-utf" *ngIf="showSendCode">
      <div class="col-12" id="profile-number-section" *ngIf="showNumberSection">
        <div id="customer-profile-heading">
          <h2>{{ cfetLabels.utf_customer_profile.number_sub_heading }}</h2>
        </div>
        <div id="customer-profile-desc">
          <div id="profile-desc1">
            <p [innerHTML]="cfetLabels.utf_customer_profile.profile_decs1_number"></p>
          </div>
        </div>
        <label for="mobile-number-label" id="mobile-number-label">{{
          cfetLabels.utf_customer_profile.number_text}}</label>
        <div id="wireless-number">
          <span>
          <img id="merge-icon" src="assets/images/smartphone.png" alt="smartphone-icon">
          <span>{{ cfetLabels.utf_customer_profile.number }}{{ wirelessNumber }}</span>
        </span>
      </div>
        <a id="email-link" tabindex="0" (click)="showEmail($event)" (keyup)="showEmail($event)">{{
          cfetLabels.utf_customer_profile.use_email }}</a>
      </div>

      <div class="col-12" id="profile-email-section" *ngIf="showEmailSection">
        <div id="customer-profile-heading">
          <h2>{{ cfetLabels.utf_customer_profile.email_sub_heading }}</h2>
        </div>
        <div id="customer-profile-desc">
          <div id="profile-desc1">
            <p [innerHTML]="cfetLabels.utf_customer_profile.profile_decs1_email"></p>
          </div>
        </div>
        <label for="email-id-label" id="email-id-label">{{ cfetLabels.utf_customer_profile.email_add }}</label>
        <h2 id="email-id">
          {{ cfetLabels.utf_customer_profile.email }}{{ emailAddress }}
        </h2>
        <a id="number-link" tabindex="0" (click)="showNumber($event)" (keyup)="showNumber($event)">{{
          cfetLabels.utf_customer_profile.use_mobile }}</a>
      </div>
      <div class="row no-gutters">
        <div class="col-12">
          <div class="dividercomp section">
            <div class="row" id="action-divider"></div>
          </div>
        </div>
        <div class="col-12" id="profile-footer-column1">
          <a id="link-cancel" tabindex="0" (click)="cancel($event)" (keyup)="cancel($event)">{{
            cfetLabels.utf_customer_profile.cancel }}</a>
            <button tabindex="0" type="button" id="back-btn" class="backBtn btn btn-medium" (click)="goBack($event)" (keyup)="goBack($event)">
              {{cfetButtonLabels.button_labels.back}}</button>
          <button type="button" id="btn-send" (click)="sendCode($event)" (keyup)="sendCode($event)"
            class="btn btn-medium" tabindex="0">
            <em aria-label=""></em>
            {{ cfetLabels.utf_customer_profile.send_code }}
          </button>
        </div>
      </div>
    </div>

    <div class="customer-profile-code" id="customer-profile-code" *ngIf="showCodeVerification">
      <div id="customer-profile-heading1">
        <h2>{{ cfetLabels.utf_customer_profile.sub_heading1 }}</h2>
      </div>
      <div id="code-sent-to">
        <label for="code-sent-label" id="code-sent-label"
          [innerHTML]="cfetLabels.utf_customer_profile.enter_code"></label>
        <label for="code-sent-label1" id="code-sent-label1" *ngIf="displayUsedNumber">
          {{cfetLabels.utf_customer_profile.enter_code1}}
          <span id="span_tag">{{cfetLabels.utf_customer_profile.enter_code2}}</span>
          {{cfetLabels.utf_customer_profile.enter_code3}}{{ cfetLabels.utf_customer_profile.number }}{{ wirelessNumber
          }}
        </label>
        <label for="code-sent-label1" id="code-sent-label1" *ngIf="displayUsedEmail">
          {{cfetLabels.utf_customer_profile.enter_code1}}
          <span id="span_tag">{{cfetLabels.utf_customer_profile.enter_code2}}</span>
          {{cfetLabels.utf_customer_profile.enter_code3}}{{ cfetLabels.utf_customer_profile.email }}{{ emailAddress }}
        </label>
      </div>

      <div id="expires-in">
        <label for="time-label" id="time-label">{{ cfetLabels.utf_customer_profile.time_remaining}}</label>
        <span id="timer-count">{{ minutes }}:{{ seconds }}</span>
      </div>

      <div class="row form-row" id="input-code" [class.error]="securityCodeError || timeExpired">
        <input id="received-code" class="received-code" name="code" tabindex="0" maxlength="256" autocomplete="off"
          type="text" formControlName="securityCode" placeholder="Enter your code" aria-label="Activation OTP"
          [class.error]="securityCodeError" (blur)="checkOTP()" />
        <div *ngIf="timeExpired" role="alert" [attr.aria-atomic]="true" [ngClass]="{ 'error-msg': timeExpired }">
          <em class="icon-badgealert" aria-hidden="true"></em>
          <span *ngIf="timeExpired" [innerHTML]="cfetMessages.otp_code_expired"></span>
        </div>
      </div>

      <div id="resend-link-section">
        <div id="resend-link">
          <a id="link-resend" tabindex="0" (click)="resendCode($event)" (keyup)="resendCode($event)">{{
            cfetLabels.utf_customer_profile.resend_code }}</a>
        </div>
        <div id="use-email">
          <a id="link-use-email" *ngIf="useEmailInstead" tabindex="0" (click)="useEmail($event)"
            (keyup)="useEmail($event)">{{ cfetLabels.utf_customer_profile.use_email }}</a>
          <a id="link-use-email" *ngIf="useNumberInstead" tabindex="0" (click)="useNumber($event)"
            (keyup)="useNumber($event)">{{ cfetLabels.utf_customer_profile.use_mobile }}</a>
        </div>
      </div>
      <div class="dividercomp section">
        <div class="row" id="action-divider"></div>
      </div>
      <div id="profile-footer-column" class="profile-footer-column">
        <div class="col-md-12" class="btn-container">
          <a tabindex="0" type="button" id="cancel_link" tabindex="0" (click)="cancel($event)" (keyup)="cancel($event)">
            <em aria-label=""></em>
            {{cfetButtonLabels.button_labels.cancel}}</a>
          <button tabindex="0" type="button" id="back-btn" (click)="back($event)" (keyup)="back($event)">
            {{cfetButtonLabels.button_labels.back}}</button>
          <button tabindex="0" type="button" id="btn-submit" class="btn btn-alt btn-medium" (click)="submit()"
            (keyup)="submit()" [disabled]="disabledSubmitButton()"><em aria-label=""></em>
            {{cfetButtonLabels.button_labels.submit}}</button>
        </div>
      </div>
    </div>
  </form>

  <div [ngClass]="showInactivityModal ? 'open-utf-inactivity-modal' : ''">
    <app-customer-inactivity-utf-modal [openModal]="openInactivityModal"
      (closeInactivityModal)="closeInactivityModal($event)">
    </app-customer-inactivity-utf-modal>
  </div>
</div>
<app-custom-spinner *ngIf="showLoading"></app-custom-spinner>
<div [ngClass]="showCancelModal ? 'open-utf-cancel-modal' : 'hide-cancel-modal'">
  <app-customer-utf-cancel-modal [openModal]="openCancelModal" (closeCancelModal)="closeCancelModal($event)">
  </app-customer-utf-cancel-modal>
</div>
<div id="customer-complete-profile-confirmation-container" *ngIf="showCompleteProfileSection">
  <div id="customer-complete-profile-confirmation">
    <app-complete-profile-confirmation-utf></app-complete-profile-confirmation-utf>
  </div>
</div>